import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C6.48601 2 2 6.48601 2 12C2 17.514 6.48601 22 12 22C17.514 22 22 17.514 22 12C22 6.48601 17.514 2 12 2ZM11.6621 7.0957C12.0771 7.0957 12.4121 7.4317 12.4121 7.8457V12.2676L15.8164 14.2969C16.1714 14.5099 16.2882 14.9702 16.0762 15.3262C15.9352 15.5612 15.6866 15.6934 15.4316 15.6934C15.3006 15.6934 15.1679 15.6589 15.0469 15.5879L11.2773 13.3379C11.0513 13.2019 10.9121 12.9574 10.9121 12.6934V7.8457C10.9121 7.4317 11.2481 7.0957 11.6621 7.0957Z",
		fill: "currentColor"
	})
});
export default SvgTimeCircleFill;
